function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5533 3.45393L10.4983 1.39888C10.2301 1.14694 9.8786 1.00239 9.51075 0.992707C9.1429 0.983027 8.78432 1.1089 8.50322 1.34638L1.75305 8.09655C1.51062 8.34103 1.35967 8.66147 1.32554 9.00408L1.00303 12.1317C0.992927 12.2415 1.00718 12.3522 1.04478 12.456C1.08237 12.5597 1.14239 12.6538 1.22054 12.7317C1.29062 12.8012 1.37373 12.8562 1.46511 12.8935C1.55649 12.9308 1.65434 12.9497 1.75305 12.9492H1.82055L4.94813 12.6642C5.29074 12.63 5.61118 12.4791 5.85566 12.2367L12.6058 5.48649C12.8678 5.2097 13.0094 4.84035 12.9996 4.45936C12.9897 4.07837 12.8293 3.71682 12.5533 3.45393ZM4.81313 11.1641L2.56307 11.3741L2.76558 9.12408L7.00319 4.93897L9.02824 6.96402L4.81313 11.1641ZM10.0033 5.959L7.99321 3.94894L9.45575 2.44891L11.5033 4.49646L10.0033 5.959Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.2
});

function SvgEditicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/edit.icon.13b03a22.svg";
export { ForwardRef as ReactComponent };